<!-- /src/components/common/Sidebar/SubMenu.vue -->
<template>
  <ul 
    v-scroll-spy-active="active"
    v-scroll-spy-link
    class="submenu sidebar-submenu"
    :data-scroll-spy-id="scrollSpyID"
    v-scroll-spy="{allowNoActive: true}"
  >
    <li class="sidebar-submenu__item"
      v-for="item in menuItems"
      :key="item"
    >
      <a class="sidebar-submenu__itemLink">{{ item }}</a>
    </li>
  </ul>
</template>

<script>
import defaults from 'lodash/defaults'
import isUndefined from 'lodash/isUndefined'


export default {
  props: {
    menuItems: {
      type: Array,
      required: true,
    },
    scrollSpyID: {
      type: String,
      required: false,
    },
    scrollSpyActive: {
      type: Object,
      required: false,
    }
  },

  computed: {
    active() {
      const { scrollSpyActive } = this
      let defaultOutput = {
        selector: 'li.sidebar-submenu__item', 
        class: 'active',
      }

      return !isUndefined(scrollSpyActive) ? defaults(scrollSpyActive, defaultOutput) : defaultOutput
    }
  },

  methods: {
    matchHeight () {
      let height = this.$refs.departments ? this.$refs.departments.clientHeight : 0;
    }
  },

  mounted () {
   this.matchHeight()
  },

}
</script>

<style scoped>

.sidebar-submenu {
  &__item {
    font-size: 1rem;
    font-weight: bold;
    /* text-transform: uppercase; */
    padding: 0.25rem 0 0.75rem 0;
    line-height: 1;

    &.active {
      a {
        color: var(--brandAccent);
        &:after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 0;
          height: 4px;
          width: 100%;
          background-color: var(--brandAccent);
          transition: width 0.5s ease;
          will-change: width;
        }
      }
    }
    &Link {
      display: block;
      position: relative;
      transition: color 0.5s ease;
      will-change: color;

      &:after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 0;
        height: 4px;
        width: 0;
        background-color: var(--brandAccent);
        transition: width 0.5s ease;
        will-change: width;
      }

      &:hover {
        color: var(--brandAccent);
      }

      &:hover:after {
        width: 100%;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
